// extracted by mini-css-extract-plugin
module.exports = {"heading":"style_heading__19ASv","description":"style_description__wJl_m","textArea":"style_textArea__3S8AB"};